import { render, staticRenderFns } from "./AddressEditor.vue?vue&type=template&id=717c9f5f&scoped=true&"
import script from "./AddressEditor.vue?vue&type=script&lang=js&"
export * from "./AddressEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717c9f5f",
  null
  
)

export default component.exports